export const BASE_URL = "https://studenttasks.onrender.com/";
// eslint-disable-next-line
const LOCAL_BASE_URL = "http://localhost:3001/";
